import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconAvailabilityRequest = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1875 1.875H14.0625C14.58 1.875 15 2.295 15 2.8125V14.0625C15 14.58 14.58 15 14.0625 15H0.9375C0.42 15 0 14.58 0 14.0625V2.8125C0 2.295 0.42 1.875 0.9375 1.875H2.8125V0H5.625V1.875H9.375V0H12.1875V1.875ZM8.42308 11.1006H6.65976V12.8107H8.42308V11.1006ZM5.67751 4.4497C4.93984 4.91913 4.54734 5.71598 4.5 6.84024H6.21006C6.21006 6.51282 6.30473 6.19724 6.49408 5.89349C6.68738 5.58974 7.01282 5.43787 7.47041 5.43787C7.9359 5.43787 8.25542 5.56213 8.42899 5.81065C8.60651 6.05523 8.69527 6.32742 8.69527 6.62722C8.69527 6.88757 8.61637 7.12623 8.45858 7.3432C8.37179 7.46943 8.2574 7.5858 8.11539 7.69231L7.68343 8.02959C7.2574 8.36095 6.9931 8.65483 6.89053 8.91124C6.78797 9.16371 6.72485 9.62327 6.70118 10.2899H8.29882C8.30276 9.97436 8.3284 9.74162 8.37574 9.59172C8.45069 9.35503 8.60256 9.14793 8.83136 8.97041L9.25148 8.64497C9.67752 8.31361 9.96548 8.04142 10.1154 7.8284C10.3718 7.47732 10.5 7.04536 10.5 6.53254C10.5 5.69625 10.2041 5.06509 9.61243 4.63905C9.02465 4.21302 8.28501 4 7.39349 4C6.71499 4 6.143 4.1499 5.67751 4.4497Z",
		fill: "currentColor"
	})
});
export default SvgIconAvailabilityRequest;
